import React from "react";
import PropTypes from "prop-types";
import { H3 } from "theme/components/atoms/Typography/Heading";
import Icon from "theme/components/atoms/Icon";
import classnames from "classnames";

const FilterItem = (props) => {
  const [opened, setOpened] = React.useState(props.initiallyOpen);
  const className = classnames("filter", {
    "filter--opened": opened,
  });

  return (
    <div className={className}>
      <div className="filter__title" onClick={() => setOpened(!opened)}>
        <H3 as="div">{props.label}</H3>
        {opened ? (
          <Icon icon="chevron-up" size="tiny" title="close" />
        ) : (
          <Icon icon="chevron-down" size="tiny" title="open" />
        )}
      </div>
      <div className="filter__content">
        {props.children ? props.children(opened) : ""}
      </div>
    </div>
  );
};

FilterItem.propTypes = {
  label: PropTypes.node.isRequired,
  initiallyOpen: PropTypes.bool,
};

FilterItem.defaultProps = {
  initiallyOpen: false,
};

export default FilterItem;
